<template>
  <Form ref="loginForm" :model="form" :rules="rules" @keydown.enter.native="handleSubmit">
        <div >
    <ul class="list">
       <li class="" >
         <div class="identity"><i class="name"></i></div>
          <FormItem prop="userName">
              <input v-model="form.userName" value placeholder="请输入账号" />
              </input>
          </FormItem>
        </li>
       <li class="">
         <div class="identity"><i class="password"></i></div>
          <FormItem prop="password">
              <input type="password" v-model="form.password" placeholder="请输入密码">
              </input>
          </FormItem>
        </li>
       <li class="button">
          <FormItem>
              <input class="button"  @click="handleSubmit" type="button" value="登录进入实验" placeholder="">
          </FormItem>
       </li>
    </ul>
        </div>
  </Form>
</template>
<script>
export default {
  name: "LoginForm",
  props: {
    userNameRules: {
      type: Array,
      default: () => {
        return [{ required: true, message: "账号不能为空", trigger: "blur" }];
      },
    },
    passwordRules: {
      type: Array,
      default: () => {
        return [{ required: true, message: "密码不能为空", trigger: "blur" }];
      },
    },
  },
  data() {
    return {
      form: {
        userName: "",
        password: "",
      },
    };
  },
  computed: {
    rules() {
      return {
        userName: this.userNameRules,
        password: this.passwordRules,
      };
    },
  },
  methods: {
    handleSubmit() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.$emit("on-success-valid", {
            userName: this.form.userName,
            password: this.form.password,
          });
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/loginForm/loginForm.vue